import React, { FC, useEffect, useState } from 'react';
import { PrimaryButton, IDropdownOption, Label, Icon, SpinnerSize, Spinner} from '@fluentui/react';
import { Dropdown, Dialog, Checkbox } from '@eta/components';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isNull } from 'util';
import { ReduxState } from '../../common/reducers';
import { saveCurrentNotifications } from '../Redux/Actions';
import {
    RecipientPreferenceRequestDto,
    RecipientNotificationPreferenceRequestDto,
    NotificationChannels,
    RecipientUserPreferenceDto,
    NotificationTypes,
} from '../../Services/ClientProxy/NotificationManagementClient';

import './NotificationDialog.scss';

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.profile.lastError,
});

const mapDispatchToProps = {
    dispatchSaveCurrentNotifications: saveCurrentNotifications,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface NotificationDialogProps {
    hidden: boolean;
    onClose: () => void;
    notifications: RecipientUserPreferenceDto | undefined;
    onSave: () => void;
}
export const NotificationDialog: FC<
    PropsFromRedux & NotificationDialogProps
> = (props: PropsFromRedux & NotificationDialogProps) => {
    const { t } = useTranslation(['resources', 'common', 'myProfile']);
    const optionsNotificationChannels: IDropdownOption[] = [
       
        { key: NotificationChannels.Sms, text: t('constants.SMS') },
        { key: NotificationChannels.Email, text: t('constants.Email') },
    ];
    const { dispatchSaveCurrentNotifications, notifications, onSave, hidden, onClose } = props;

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [notificationChannelId, setnotificationChannelId] = useState<
        NotificationChannels
    >();
    const [IsDocomentPachageReady, setIsDocomentPachageReady] = useState<
        boolean
    >();
    const [isReceiptPackageReady, setIsReceiptPackageReady] =
        useState<boolean>();

    const SaveNotification = async () => {
        setIsSaving(true);
        const request = new RecipientPreferenceRequestDto();
        request.notificationChannelId =
            notificationChannelId ?? NotificationChannels.None;
        request.recipientNotificationPreferences = [];
        if (IsDocomentPachageReady) {
            request.recipientNotificationPreferences.push(
                new RecipientNotificationPreferenceRequestDto({
                    isSubscribed: true,
                    notificationTypeId: NotificationTypes.ReceiveDownloadReady,
                })
            );
        }
        if (isReceiptPackageReady) {
            request.recipientNotificationPreferences.push(
                new RecipientNotificationPreferenceRequestDto({
                    isSubscribed: true,
                    notificationTypeId: NotificationTypes.ReceiptPackageDownloadReady,
                })
            );
        }
        
        const response = await dispatchSaveCurrentNotifications(request);

        if (isNull((await response.payload).lastError)) {
            
            onSave();
        }
        setIsSaving(false);
    };

    useEffect(() => {
        if (notifications) {
            setnotificationChannelId(notifications?.notificationChannelId);
            const pref = notifications.recipientNotificationPreferences;
            if (pref && pref.length > 0) {
                for (let i = 0; i < pref.length; i += 1) {
                    const notify = pref[i];

                    if (notify !== undefined) {
                        switch (notify.notificationTypeId) {
                            case NotificationTypes.ReceiveDownloadReady:
                                setIsDocomentPachageReady(notify.isSubscribed);
                                break;
                            case NotificationTypes.ReceiptPackageDownloadReady:
                                setIsReceiptPackageReady(notify.isSubscribed);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        }
    }, [notifications]);
    return (
        <Dialog
            containerClassName= "notificationDialog"
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={450}
            title={(
                <>
                    <Icon iconName="Message" />{' '}
                    <span>{t('myProfile:notificationDialog_title')}</span>
                </>
              )}
            Footer={(
                <PrimaryButton
                    className='saveButton'
                    onClick={() => SaveNotification()}
                    text={t('common:save')}
                    disabled={isSaving}
                >
                    {isSaving && <Spinner size={SpinnerSize.small}/>}
                    </PrimaryButton>
              )}
        >
            <Dropdown
                containerClassName='notifChannel'
                label={t('myProfile:notificationDialog_NotifChannel')}
                options={optionsNotificationChannels}
                selectedKey={notificationChannelId}
                onChange={(_, option) =>
                    setnotificationChannelId(
                        option?.key
                            ? (option.key as NotificationChannels)
                            : NotificationChannels.None
                    )
                }
            />
            <Label className='subscripeLabel'>{t('myProfile:notificationDialog_Subscriptions')}</Label>
            <Checkbox
                label={t('myProfile:notificationDialog_DocumentPackageReady')}
                checked={IsDocomentPachageReady}
                onChange={(_, v) => setIsDocomentPachageReady(v)}
            />
            <br/>
            <Checkbox
                label={t('myProfile:notificationDialog_ReceiptPackageReady')}
                checked={isReceiptPackageReady}
                onChange={(_, v) => setIsReceiptPackageReady(v)}
            />
        </Dialog>
    );
};

export default connector(NotificationDialog);
